import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTermValue, TJsonQuery } from '../../../../packages/JsonQuery';
import { trackPaginationClick } from '../../../ListingDesktop/containers/ListingDesktopFooterContainer/tracking';
import { ETestId } from '../../../common/constants/testId';
import { usePaginationActions } from '../../../common/hooks/usePaginationActions';
import { selectJsonQuery } from '../../../common/selectors/filters';
import { trackListingShow } from '../../../common/tracking';
import { ListingMobileFooter } from '../../components/ListingMobileFooter';

interface IListingMobileFooterContainerProps {
  className?: string;
}

const onAfterChange = trackListingShow('all_objects_on_map');

const handleScrollTop = () => {
  document.getElementById(ETestId.ListingMobileContent)?.scrollTo(0, 0);
};

export const ListingMobileFooterContainer: React.FC<IListingMobileFooterContainerProps> = ({ className }) => {
  const { hasPrev, hasNext, isLoading, handlePrev, handleNext } = usePaginationActions({
    onBeforeChange: handleScrollTop,
    onAfterChange,
  });
  const jsonQuery = useSelector(selectJsonQuery);
  const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;

  const onPrevClick = React.useCallback(() => {
    handlePrev();
    trackPaginationClick(pageNumber - 1);
  }, [pageNumber]);

  const onNextClick = React.useCallback(() => {
    handleNext();
    trackPaginationClick(pageNumber + 1);
  }, [pageNumber]);

  return (
    <ListingMobileFooter
      onPrevClick={onPrevClick}
      onNextClick={onNextClick}
      onScrollTopClick={handleScrollTop}
      hasPrev={hasPrev}
      hasNext={hasNext}
      isLoading={isLoading}
      className={className}
    />
  );
};

ListingMobileFooterContainer.displayName = 'ListingMobileFooterContainer';
